import "firebase/firestore";

import { Component, Prop, Vue } from "vue-property-decorator";
import { CreateElement } from "vue";

import "@/firebase";
import { db, parentConsentCollection } from "@/firebase";
import GlobalAuth from "./rules";

@Component
export default class QuestionnaireParent extends Vue {
  // @Prop() callbackOnComplete!: (callbackToSubmitQuestionnaire: any) => void;
  // @Prop() backToParentConsent!: () => void;
  @Prop() consentDocId!: string | undefined; // {}
  private rules = GlobalAuth;

  private yesno = ["Yes", "No", "I don't know"];
  private yesnostrict = ["Yes", "No"];
  private rating = [
    "Not well at all",
    "Not that well",
    "Somewhat well",
    "Well",
    "Very Well"
  ];
  private native = [
    "No",
    "Yes, First Nations",
    "Yes, Metis",
    "Yes, Inuit",
    "Yes, Other Indigenous peoples"
  ];
  private support = [
    "Yes",
    "No, They don't need any support",
    "No, but they need support"
  ];

  input: any = {};
  collection = parentConsentCollection;

  created() {
    this.input["languages"] = [{ language: "", rating: -1 }];
    window.scrollTo(0, 0);
  }

  submit() {
    // validate function exists
    if (
      (this.$refs.form as any).validate() &&
      this.collection &&
      this.consentDocId
    ) {
      // send data to server
      this.collection
        .doc(this.consentDocId)
        .update(this.input)
        .then(() => {
          this.$store.dispatch("addNotification", {
            type: "success",
            value: `Parent Questionnaire submitted sucessfully. Thank you for participating.`,
            timeout: 4000,
            icon: "mdi-file-document"
          });
          this.$router.push({ path: "/" });
        })
        .catch(err => {
          this.$store.dispatch("addNotification", {
            type: "error",
            value: `Parent Questionnaire failed to submit. Please try again.`,
            timeout: 6000,
            icon: "mdi-file-document"
          });
        });
    }
  }

  private differentLanguages() {
    let languages = this.input["languages"];

    return (
      <span>
        {languages.map((obj: any, i: number) => (
          <div>
            <v-text-field
              label={"Language " + (i + 1)}
              name={"language " + (i + 1)}
              rules={this.rules.textRulesNotRequired}
              v-model={this.input["languages"][i].language}
              autocomplete
            ></v-text-field>
            <p>How well does your child know this language?</p>
            <v-select
              name={"Language " + (i + 1) + " Rating"}
              v-model={this.input["languages"][i].rating}
              items={this.rating}
            ></v-select>
          </div>
        ))}
        {
          <span>
            <v-input>
              <v-btn
                style={{ margin: "0 0 0 auto" }}
                text
                color="green"
                onClick={() => {
                  this.input["languages"].push({
                    language: "",
                    rating: -1
                  });
                  this.$forceUpdate();
                }}
              >
                Add more
              </v-btn>
              {this.input["languages"].length > 1 ? (
                <v-btn
                  text
                  color="red"
                  onClick={() => {
                    this.input["languages"].pop();
                    this.$forceUpdate();
                  }}
                >
                  Remove
                </v-btn>
              ) : (
                ""
              )}
            </v-input>
          </span>
        }
      </span>
    );
  }

  private _inputValid: boolean = false;
  render(h: CreateElement) {
    return (
      <v-container class="fill-height" fluid>
        <v-row justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="accent" dark flat>
                <v-toolbar-title>Parent Questionnaire</v-toolbar-title>
              </v-toolbar>
              <v-form ref="form" v-model={this._inputValid}>
                <v-card-text>
                  Which country does your child live in?
                  <v-text-field
                    label="Country"
                    name="country"
                    rules={this.rules.textRules}
                    type="text"
                    v-model={this.input["countryLivesIn"]}
                    required
                    autocomplete
                  ></v-text-field>
                  Which city does your child live in?
                  <v-text-field
                    label="City"
                    name="city"
                    rules={this.rules.textRules}
                    type="text"
                    v-model={this.input["cityLivesIn"]}
                    required
                    autocomplete
                  ></v-text-field>
                  Was your child born in Canada?
                  <v-select
                    name="bornInCanada"
                    v-model={this.input["bornInCanada"]}
                    items={this.yesnostrict}
                    rules={this.rules.required}
                    required
                  ></v-select>
                  {this.input["bornInCanada"] == "No" ? (
                    <span>
                      If your child was not born in Canada, how old were they
                      when they moved to Canada?
                      <v-text-field
                        label="Age"
                        name="moveInAge"
                        rules={this.rules.integerRules}
                        type="number"
                        min={0}
                        v-model={this.input["moveInAge"]}
                        required
                        autocomplete
                      ></v-text-field>
                    </span>
                  ) : (
                    ""
                  )}
                  Do you identify your child as First Nations, Metis, Inuit, or
                  other Indigenous peoples?
                  <v-select
                    name="native"
                    v-model={this.input["native"]}
                    items={this.native}
                    rules={this.rules.required}
                    required
                  ></v-select>
                  <br></br>
                  <p>Think about all the languages your child knows. </p>
                  <br></br>
                  How well does your child know English?
                  <v-select
                    name="englishRating"
                    v-model={this.input["englishRating"]}
                    items={this.rating}
                    required
                    rules={this.rules.required}
                  ></v-select>
                  Is English your child's first language? (the language your
                  child learned first)
                  <v-select
                    name="firstLanguage"
                    v-model={this.input["firstLanguage"]}
                    items={this.yesnostrict}
                    required
                    rules={this.rules.required}
                  ></v-select>
                  If your child knows a language other than English, how well do
                  they know that language? (To add additional languages your
                  child knows, click{" "}
                  <b color="green">
                    <em>ADD MORE</em>
                  </b>
                  )
                  <br />
                  <br />
                  {this.differentLanguages()}
                  Is your child currently in an ESL (English as a Second
                  Language) class?
                  <v-select
                    name="inESLclass"
                    v-model={this.input["inESLclass"]}
                    items={this.yesnostrict}
                    rules={this.rules.required}
                    required
                  ></v-select>
                  Has your child taken any ESL (English as a Second Language)
                  class? (Could be at school or another location)
                  <v-select
                    name="ESL"
                    v-model={this.input["takenESL"]}
                    items={this.yesnostrict}
                    required
                    rules={this.rules.required}
                  ></v-select>
                  {this.input["takenESL"] == "Yes" ? (
                    <span>
                      How many ESL classes has your child taken?
                      <v-text-field
                        label="Number of Classes"
                        name="numEslClasses"
                        rules={this.rules.integerRules}
                        type="number"
                        min={0}
                        v-model={this.input["numEslClasses"]}
                        required
                        autocomplete
                      ></v-text-field>
                      How old was your child when they first took an ESL class?
                      <v-text-field
                        label="Age"
                        name="firstEslAge"
                        rules={this.rules.integerRules}
                        type="number"
                        min={0}
                        v-model={this.input["firstEslAge"]}
                        required
                        autocomplete
                      ></v-text-field>
                    </span>
                  ) : (
                    ""
                  )}
                  <br></br>
                  <p>
                    <b>
                      BalanceAI is designed to provide support for students'
                      learning, so we'd like to know about your child's learning
                      experience.
                    </b>
                  </p>
                  <br></br>
                  Does your child have an IEP (Individual Education Plan)?
                  <v-select
                    name="IEP"
                    v-model={this.input["hasIEP"]}
                    items={this.yesnostrict}
                    rules={this.rules.required}
                    required
                  ></v-select>
                  Is your child in a Special Education program?
                  <v-select
                    name="IEP"
                    v-model={this.input["inSpecEd"]}
                    items={this.yesnostrict}
                    rules={this.rules.required}
                    required
                  ></v-select>
                  Does your child have any difficulties with learning?
                  <v-select
                    name="hasDifficultyLearning"
                    v-model={this.input["hasDifficultyLearning"]}
                    items={this.yesnostrict}
                    rules={this.rules.required}
                    required
                  ></v-select>
                  {this.input["hasDifficultyLearning"] == "Yes" ? (
                    <span>
                      Is your child getting any support for their difficulties
                      with learning?
                      <v-select
                        name="hasSupport"
                        v-model={this.input["hasSupport"]}
                        items={this.support}
                        required
                        rules={this.rules.required}
                      ></v-select>
                    </span>
                  ) : (
                    ""
                  )}
                  {this.input["hasDifficultyLearning"] == "Yes" &&
                  this.input["hasSupport"] == "Yes" ? (
                    <span>
                      Please list any learning supports that your child is
                      recieving.
                      <v-text-field
                        label="Learning Supports"
                        name="learningSupports"
                        rules={this.rules.listRules}
                        type="text"
                        v-model={this.input["learningSupports"]}
                        autocomplete
                      ></v-text-field>
                    </span>
                  ) : (
                    ""
                  )}
                  Has your child been formally diagnosed for learning
                  difficulties?
                  <v-select
                    name="formallyDiagnosed"
                    v-model={this.input["formallyDiagnosed"]}
                    items={this.yesno}
                    // rules={this.rules.required}
                    required
                  ></v-select>
                  {this.input["formallyDiagnosed"] == "Yes" ? (
                    <span>
                      Describe any known learning difficulty diagnoses that your
                      child has.
                      <v-text-field
                        label="Learning Difficulty Diagnoses"
                        name="difficultyDiagnoses"
                        rules={this.rules.listRules}
                        type="text"
                        v-model={this.input["difficultyDiagnoses"]}
                        autocomplete
                      ></v-text-field>
                    </span>
                  ) : (
                    ""
                  )}
                  Please provide any further information you would like to share
                  about your child’s strengths and challenges in language
                  (reading, speaking, and writing) here.
                  <v-textarea
                    label="Child's strengths and challenges"
                    name="childStrengthChallenges"
                    // type="text"
                    v-model={this.input["childStrengthChallenges"]}
                    autocomplete
                  ></v-textarea>
                </v-card-text>
              </v-form>
              <v-card-actions>
                <v-btn
                  disabled={!this._formComplete()}
                  color="accent"
                  onclick={this.submit}
                >
                  Complete Questionnaire
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    );
  }
  private _formComplete() {
    let form = this.$refs.form as any;
    return form && form.validate();
  }
}

const component = QuestionnaireParent;
